const status = ["Active", "Pending", "Completed"];
const AuctionData = [...Array(50)].map((_, index) => {
  return {
    LotNo: index + 1,
    Origin: "Country A",
    Type: "Type 1",
    Subtype: "Subtype 1",
    Ctgry: "Category 1",
    Mark: "Mark 1",
    Grade: "Grade 1",
    Pkgs: "10",
    BasePrice: "100",
    Bidder: "Bidder 1",
    Status: status[Math.floor(Math.random() * status.length)],
    Ntwt: "50",
    Grwt: "60",
    "Total Ntwt": "500",
    "Per. of Mfg": "80%",
    PkgCmnts: "Comments 1",
    LotType: "Type A",
    GPNo: "GP-001",
    GPDate: "2023-06-01",
    "Inv. No": "INV-001",
    "LSP/SP": "LSP-001",
    PriceIncrement: "PL-001",
    PkgNo: "PKG-001",
    WarehouseName: "Warehouse A",
    Increment: "5",
    Garden: "Garden 1",
    Special: "Special 1",
    Quality: "High",
    "Colour of": "Red",
    "Age of": "1 year",
    Brewers: "Brewer 1",
    NumofBidders: "3",
    "Active Since": "2022-01-01",
    Price: "120",
    My: "Yes",
    Confirm: "Yes",
    IN: "IN-001",
    OUT: "OUT-001",
  };
});

export default AuctionData;
